import { render, staticRenderFns } from "./TableFeedbacks.vue?vue&type=template&id=4b5e87f5"
import script from "./TableFeedbacks.vue?vue&type=script&lang=js"
export * from "./TableFeedbacks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports